import { render, staticRenderFns } from "./GalleryDetails.vue?vue&type=template&id=f94145ac&scoped=true&"
import script from "./GalleryDetails.vue?vue&type=script&lang=js&"
export * from "./GalleryDetails.vue?vue&type=script&lang=js&"
import style0 from "./GalleryDetails.vue?vue&type=style&index=0&id=f94145ac&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94145ac",
  null
  
)

export default component.exports